import React from 'react';
import StatusBadge from '../../Components/Common/StatusBadge';
import { PUBLIC_STATUS } from './services/tenderAnnouncementService';
import { EMPTY_VALUE } from './formatters';
import { usePublicLanguage } from './i18n/LanguageContext';

const STATUS_TONE = {
  [PUBLIC_STATUS.BIDDING_OPEN]: 'success',
  [PUBLIC_STATUS.BIDDING_CLOSED]: 'danger',
  [PUBLIC_STATUS.ANNOUNCED]: 'info',
};

const TenderStatusBadge = ({ status, className = '' }) => {
  const { t } = usePublicLanguage();

  const tone = STATUS_TONE[status];
  // Status values stay English (codes from the backend); only the label is
  // translated.
  const label = tone ? t(`status.${status}`) : EMPTY_VALUE;

  return (
    <StatusBadge
      tone={tone || 'muted'}
      label={label}
      className={`public-tender__status ${className}`.trim()}
    />
  );
};

export default TenderStatusBadge;
